export const ZEME_USER_DATA = 'zeme_user_data';
export const ZEME_CHAT_ROOM_DATA = 'zeme_chat_room_data';
